import React, { FC, useCallback } from 'react';
import { pick } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { messages } from '../../../../i18n';
import { updateOptions } from '../../../../actions';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { optionsInitialState } from '../../../../reducers/options';
import { useOptions, useConfig } from '../../../../selectors';
import { TextLine } from '../../common/TextLine';
import { MediumSelectables } from '../../common/selectable/containers/MediumSelectabes';
import { SelectableTheme } from './SelectableTheme';

const Root = styled.div`
  margin-top: ${globalTheme.spacing.md}
`;

export const Themes: FC = () => {
  const analytics = useAnalytics();
  const dispatch = useDispatch();
  const { selectedThemeIndex } = useOptions();
  const config = useConfig();

  const handleThemeClick = useCallback((index: number, themeName: string) => {
    analytics('edit general', themeName);
    dispatch(updateOptions({
      ...pick(optionsInitialState, [
        'selectedAssetIndex',
        'selectedLogoIndex',
      ]),
      selectedThemeIndex: index,
    }));
  }, [analytics, dispatch]);

  return (
    <Root>
      <TextLine>
        <FormattedMessage {...messages['section.general.customizeThisDemoTheme']} />
      </TextLine>
      <MediumSelectables data-test="themes-container">
        {config.themes.map((theme, index) =>
          <MediumSelectables.Item key={index}>
            <SelectableTheme
              isSelected={selectedThemeIndex === index}
              onClick={() => handleThemeClick(index, theme.name)}
              theme={theme}
              themeIndex={index}
            />
          </MediumSelectables.Item>
        )}
      </MediumSelectables>
    </Root>
  );
};
